import { render, staticRenderFns } from "./VipExchange.vue?vue&type=template&id=6225c92c&"
import script from "./VipExchange.vue?vue&type=script&lang=js&"
export * from "./VipExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports